import { Link } from "react-router-dom";
import { Heart, Book, Mail, Instagram, Youtube } from "lucide-react";
import OrderStatusLookup from "./OrderStatusLookup";

const Footer = () => {
  return (
    <footer className="bg-[#1D3557] text-white py-12 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <OrderStatusLookup />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_farm-tales-store/artifacts/kyjajpew_1000080225%20%281%29.png" 
                alt="FarmSmartKids Logo" 
                className="w-14 h-14 rounded-2xl border-4 border-white object-cover"
              />
              <span className="text-xl font-black" style={{ fontFamily: "'Fredoka', sans-serif" }}>
                FarmSmartKids
              </span>
            </div>
            <p className="text-white/80 font-medium">
              Read. Learn. Grow. Together.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: "'Fredoka', sans-serif" }}>
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Book className="w-4 h-4" />
                  Our Book
                </Link>
              </li>
              <li>
                <Link to="/lessons" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Book className="w-4 h-4" />
                  Livestock Lessons
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Book className="w-4 h-4" />
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/activities" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Book className="w-4 h-4" />
                  Activities
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4" style={{ fontFamily: "'Fredoka', sans-serif" }}>
              Get in Touch
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="https://instagram.com/callie_detective" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Instagram className="w-4 h-4" />
                  @callie_detective
                </a>
              </li>
              <li>
                <a href="https://youtube.com/@FarmSmartKidsMarchfieldMeadows" target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Youtube className="w-4 h-4" />
                  FarmSmart Kids | Marchfield Meadows
                </a>
              </li>
              <li>
                <a href="mailto:info@farmsmartkids.com" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  info@farmsmartkids.com
                </a>
              </li>
              <li>
                <a href="mailto:author@farmsmartkids.com" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  author@farmsmartkids.com
                </a>
              </li>
              <li>
                <a href="mailto:collab@farmsmartkids.com" className="text-white/80 hover:text-white font-medium flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  collab@farmsmartkids.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-white/80 font-medium flex items-center justify-center gap-2">
            Made with <Heart className="w-4 h-4 text-[#E63946]" /> by FarmSmartKids © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
